module.exports = __webpack_public_path__ + "img/wisdom-addo.5f786efc.jpg";